import ReactTooltip from 'react-tooltip';
import React, { useCallback } from 'react';

import { changeTaskStatus } from 'modules/tasks/http';

import { ReactComponent as EyeIcon } from 'assets/icons/eye.svg';
import { ReactComponent as GirdedCheck } from 'assets/icons/girded-check.svg';
import { ReactComponent as GirdedExclamation } from 'assets/icons/girded-exclamation.svg';

const StatusTooltip = ({
  status,
  taskId,
  setTooltipOpen,
  setLocalStatus,
  setLoading,
  className,
}) => {
  const isInKeepAnEye = 'KEEP_AN_EYE' === status;

  const handleClick = useCallback(
    (status) => (event) => {
      event.stopPropagation();
      setLoading(true);
      setLocalStatus(status);

      changeTaskStatus({ taskId, status });
    },
    [taskId, setLoading, setLocalStatus]
  );

  return (
    <ReactTooltip
      id={`${taskId}-tooltip`}
      place="right"
      effect="solid"
      clickable
      type="light"
      className={className}
      delayHide={100}
      afterHide={() => {
        setTooltipOpen(false);
      }}
      afterShow={() => {
        setTooltipOpen(true);
      }}
      globalEventOff="click"
    >
      <div className="content">
        {!isInKeepAnEye && (
          <div className="content__icon-container" onClick={handleClick('review')}>
            <EyeIcon />
          </div>
        )}
        {isInKeepAnEye && (
          <div className="content__icon-container" onClick={handleClick('pending')}>
            <GirdedExclamation />
          </div>
        )}
        <div className="content__icon-container" onClick={handleClick('solve')}>
          <GirdedCheck />
        </div>
      </div>
    </ReactTooltip>
  );
};
export default StatusTooltip;
